/** PART 2: one polite live region for game events (score milestones, your
 * death, level advance, extra life, round over) -- see game/announcements.ts
 * for the pure diff->message derivation this just renders. Visually hidden
 * (`.sr-only`, index.css) so it never occupies layout space or competes
 * with the canvas/HUD visually; `aria-live="polite"` (announced without
 * interrupting whatever the screen reader is already saying) +
 * `aria-atomic` (the WHOLE region is re-read each time, not just a diff of
 * its text) is the standard idiom for this kind of transient status
 * announcement. */
export interface AnnouncerProps {
  message: string | null;
}

export function Announcer({ message }: AnnouncerProps): JSX.Element {
  return (
    <div className="sr-only" role="status" aria-live="polite" aria-atomic="true" data-testid="announcer">
      {message}
    </div>
  );
}
